import React from 'react';
import DateHelper from "../DateHelper/DateHelper";
import Tabs from '../Tabs/Tabs';
import SeasonBuilderButtons from "./SeasonBuilderButtons";
import SeasonBuilderWorkspace from "./SeasonBuilderWorkspace";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import SeasonBuilderErrors from "./SeasonBuilderErrors";

class SeasonBuilder extends React.Component {

  constructor(props) {
    super(props)

    // init all seasonal prices
    var all_seasonal_prices = [];
    for (var i = 0, ilen = this.props.all_room_types.length; i < ilen; i++) {
      var matchingSeasonalPrice = false;

      for (var j = 0, jlen = this.props.seasonal_prices.length; j < jlen; j++) {
        if (this.props.all_room_types[i].id == this.props.seasonal_prices[j].room_type_id) {
          matchingSeasonalPrice = this.props.seasonal_prices[j];
          break;
        }
      }
      // if (matchingSeasonalPrice &&
      if (matchingSeasonalPrice) {
        if(matchingSeasonalPrice.id == null){
          matchingSeasonalPrice.id = this.generateId();
        }
        all_seasonal_prices.push(matchingSeasonalPrice);
      }
    }

    var seasonal_rates
    this.props.seasonal_rates && this.props.seasonal_rates.length
      ? seasonal_rates = this.props.seasonal_rates.map(seasonal_rate => seasonal_rate.rate_id)
      : seasonal_rates = []

    this.state = {
      errors: [],
      activeTab: 'general',
      loading: false,
      all_room_types: this.props.all_room_types,
      all_rates: this.props.all_rates,
      country: this.props.country,
      exact_end_date: this.props.exact_end_date ? DateHelper.parse(this.props.exact_end_date) : null,
      exact_start_date: this.props.exact_start_date ? DateHelper.parse(this.props.exact_start_date) : null,
      holiday: this.props.holiday,
      holiday_days_after: this.props.holiday_days_after,
      holiday_days_before: this.props.holiday_days_before,
      holiday_name: this.props.holiday_name,
      holiday_region: this.props.holiday_region,
      holiday_year: this.props.holiday_year || this.props.all_years[0],

      id: this.props.id,
      name: this.props.name,
      code: this.props.code,
      read_only: typeof this.props.read_only != 'undefined' ? this.props.read_only : false,
      season_type: this.props.season_type,
      seasonal_prices: all_seasonal_prices,
      seasonal_rates: seasonal_rates,
      status: this.props.status,
      updated_at: this.props.updated_at,
    }

    this.onAddSeasonalPrice = this.onAddSeasonalPrice.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeSeasonalRates = this.onChangeSeasonalRates.bind(this);
    this.onChangeSeasonalPrices = this.onChangeSeasonalPrices.bind(this);
    // this.onRemoveSeasonalPrice = this.onRemoveSeasonalPrice.bind(this);
    this.onChangeAllDays = this.onChangeAllDays.bind(this)
    this.onChangeAllMinimumStays = this.onChangeAllMinimumStays.bind(this)
    this.onSave = this.onSave.bind(this);
    this.onSetActiveTab = this.onSetActiveTab.bind(this);
    this.onChangeYear = this.onChangeYear.bind(this);
  }

  componentDidUpdate() {
    // if (typeof initTypeahead == 'function' && this.refs.root) {
    //   window.initTypeahead($(this.refs.root).find("[data-model][data-column]"));
    // }
    if (this.refs.startDate || this.refs.endDate) {
      window.initDatepickers();
    }
  }

  render() {

    return (
      <div className="season-builder" ref="root">
        <Tabs tabs={this.tabs()} displayErrorMessage={(SeasonBuilderErrors.generalErrors(this.state.errors).length || SeasonBuilderErrors.roomTypesErrors(this.state.errors).length || SeasonBuilderErrors.ratesErrors(this.state.errors).length ) ? true : false} />
        <SeasonBuilderButtons loading={this.state.loading} read_only={this.state.read_only} nested={this.state.nested} onSave={this.onSave} />
        <div className="season">
          <div className="panel panel-form">
            <SeasonBuilderWorkspace
              {...this.state}
              date_format={this.props.date_format}
              disabled={this.props.disabled}
              onChange={this.onChange}
              onAdd={this.onAddSeasonalPrice}
              // onRemove={this.onRemoveSeasonalPrice}
              all_years={this.props.all_years}
              onChangeYear={this.onChangeYear}
              onChangeSeasonalPrices={this.onChangeSeasonalPrices}
              onChangeSeasonalRates={this.onChangeSeasonalRates}
              season_id={this.props.id}
              time_format={this.props.time_format}
              onChangeAllDays={this.onChangeAllDays}
              onChangeAllMinimumStays={this.onChangeAllMinimumStays}
              />
          </div>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  };

  tabs(){
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
          changeHandler: this.onSetActiveTab,
          tabErrorCount: SeasonBuilderErrors.generalErrors(this.state.errors).length
        },
        {
          tabName: I18n.t('room_types'),
          targetName: 'room_types',
          classes: this.state.activeTab === 'room_types' ? 'active' : null,
          changeHandler: this.onSetActiveTab,
          tabErrorCount: SeasonBuilderErrors.roomTypesErrors(this.state.errors).length
        },
        {
          tabName: I18n.t('rates'),
          targetName: 'rates',
          classes: this.state.activeTab === 'rates' ? 'active' : null,
          changeHandler: this.onSetActiveTab,
          tabErrorCount: SeasonBuilderErrors.ratesErrors(this.state.errors).length
        },
      ]
    );
  };

  onChange(event) {
    if (event && event.target) {
      // this.state[event.target.name] = event.target.value
      if (event.target.name == "season_type" && event.target.value == "exact_dates") {
        this.setState({
          country: null,
          holiday: null,
          holiday_days_after: null,
          holiday_days_before: null,
          holiday_name: null,
          holiday_region: null,
          holiday_year: this.props.all_years[0],
          season_type: event.target.value,
        })
      } else if (event.target.name == "season_type" && event.target.value == "holiday") {
        this.setState({
          season_type: event.target.value,
          holiday_days_after: 0,
          holiday_days_before: 0,
          exact_start_date: null,
          exact_end_date: null,
        })

      } else {
        this.state[event.target.name] = event.target.value
        this.forceUpdate()
      }
    }
  }

  onAddSeasonalPrice(seasonal_price) {
    var seasonal_prices = this.state.seasonal_prices.slice(0);

    if (seasonal_price && seasonal_price.id) {
      seasonal_prices.unshift(seasonal_price);
    } else {
      seasonal_prices.unshift({id: this.generateId()});
    }

    this.setState({seasonal_prices: seasonal_prices});
  }

  onChangeSeasonalPrices(seasonal_prices) {
    // console.log("seasonal_price", seasonal_prices);
    
    this.setState({seasonal_prices: seasonal_prices})
  }

  // onRemoveSeasonalPrice(idx) {
  //   var seasonal_prices = this.state.seasonal_prices.slice(0)
  //   seasonal_prices.splice(idx, 1)
  //   this.setState({seasonal_prices: seasonal_prices})
  // }

  onChangeSeasonalRates(seasonal_rates) {
    this.setState({seasonal_rates: seasonal_rates})
  }

  onChangeYear(e) {
    this.setState({holiday_year: e.target.value})
  }

  onChangeAllDays(e, id) {
    var newSeasonalPrice = this.state.seasonal_prices
    newSeasonalPrice.map((seasonal_price) => {
      if(seasonal_price.room_type_id == id) {
        seasonal_price.sunday_amount = e
        seasonal_price.monday_amount = e
        seasonal_price.tuesday_amount = e
        seasonal_price.wednesday_amount = e
        seasonal_price.thursday_amount = e
        seasonal_price.friday_amount = e
        seasonal_price.saturday_amount = e
      }
    })
    this.setState({seasonal_prices: newSeasonalPrice})
    this.forceUpdate()
  }

  onChangeAllMinimumStays(e, id){
    var newSeasonalMinimum = this.state.seasonal_prices
    newSeasonalMinimum.map((seasonal_minimum) => {
      if(seasonal_minimum.room_type_id == id) {
        seasonal_minimum.sunday_minimum_stay = e
        seasonal_minimum.monday_minimum_stay = e
        seasonal_minimum.tuesday_minimum_stay = e
        seasonal_minimum.wednesday_minimum_stay = e
        seasonal_minimum.thursday_minimum_stay = e
        seasonal_minimum.friday_minimum_stay = e
        seasonal_minimum.saturday_minimum_stay = e
      }
    })
    this.setState({seasonal_prices: newSeasonalMinimum})
  }

  onSave() {
    var self = this;
    this.setState({loading: true})
    var params = this.prepParams()
    $.ajax({
      type: this.props.new_record ? 'POST' : 'PUT',
      url: this.props.form_action,
      data: params
    }).done((data) => {

      if (data.errors && Object.keys(data.errors).length > 0) {
        this.setState({errors: data.errors, loading: false})
        $('.modal-body').scrollTop(0)
      } else {
        window.parent.$(window.parent).trigger('seasonSaved', data)

        this.setState({loading: false})
        if (parent && parent.refresh_data) {
          if (this.props.new_record == true) {
            parent.refresh_data(I18n.t('season_created_successfully'));
          } else {
            parent.refresh_data(I18n.t('season_saved_successfully'));
          }
        }

        if (parent && parent.hide_modal) {
          parent.hide_modal()
        }
      }

    }).catch((data) => {
      if (data && data.responseJSON && data.responseJSON.errors) {
        this.setState({errors: data.responseJSON.errors, loading: false})
        $('.modal-body').scrollTop(0)
      }
    })
  }

  onSetActiveTab(name) {
    this.setState({activeTab: name})
  }

  generateId() {
    var text = ""
    var possible = "0123456789"

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return '-' + text
  }

  prepParams() {
    var params = {
      season: {
        name: this.state.name,
        code: this.state.code,
        status: this.state.status,
        season_type: this.state.season_type,
        exact_start_date: this.state.exact_start_date,
        exact_end_date: this.state.exact_end_date,
        holiday_region: this.state.holiday_region,
        holiday_name: this.state.holiday_name,
        holiday_year: this.state.holiday_year,
        holiday_days_after: this.state.holiday_days_after,
        holiday_days_before: this.state.holiday_days_before,
        seasonal_prices_attributes: this.state.seasonal_prices.map((seasonal_price)=> {
          if (seasonal_price.id && seasonal_price.id[0] == "-") {
            seasonal_price.id = null
          }
          return seasonal_price
        }),
       rate_ids: this.state.seasonal_rates,
        // updated_at: this.props.updated_at,
      },
      // seasonal_prices: this.state.seasonal_prices,
      // holiday_year: this.state.holiday_year,
    }
    return params
  }

}

export default SeasonBuilder
